import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lam-loader-dialog',
  templateUrl: './loader-dialog.component.html',
  styleUrls: [],
})
export class LoaderDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<LoaderDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  public ngOnInit() {}
}
